import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function WatchlistHeart({ movieTitle, movieId, size = 18, showAuthModal }) {
  const { user, isOnWatchlist, addToWatchlist, removeFromWatchlist } = useAuth();
  const [animating, setAnimating] = useState(false);
  const isWatched = isOnWatchlist(movieTitle, movieId);

  function handleClick(e) {
    e.preventDefault();
    e.stopPropagation();

    if (!user) {
      if (showAuthModal) showAuthModal();
      return;
    }

    setAnimating(true);
    setTimeout(() => setAnimating(false), 300);

    if (isWatched) {
      removeFromWatchlist(movieTitle);
    } else {
      addToWatchlist(movieTitle, movieId);
    }
  }

  return (
    <button
      onClick={handleClick}
      title={isWatched ? 'Remove from watchlist' : 'Add to watchlist'}
      style={{
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: '2px',
        display: 'inline-flex',
        alignItems: 'center',
        transform: animating ? 'scale(1.3)' : 'scale(1)',
        transition: 'transform 0.2s ease',
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={isWatched ? '#8b6914' : 'none'}
        stroke={isWatched ? '#8b6914' : '#999'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
      </svg>
    </button>
  );
}
